import { render, staticRenderFns } from "./DataError.vue?vue&type=template&id=87447ec4&"
import script from "./DataError.vue?vue&type=script&lang=js&"
export * from "./DataError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports